import React from 'react'
import ContentLoader from 'react-content-loader'

const MobileLoader = () => (
    <div id="productTop" className="row">
        <div className="col-sm-12">
            <div className="rounded preload-widget">
                <ContentLoader
                    height={650}
                    width={400}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="550.63" y="104.61" rx="0" ry="0" width="174" height="30" />
                    <rect x="550.63" y="154.61" rx="0" ry="0" width="316" height="36" />
                    <rect x="552.63" y="211.61" rx="0" ry="0" width="177" height="38" />
                    <rect x="550.63" y="277.61" rx="0" ry="0" width="310" height="67" />
                    <rect x="58.73" y="40.61" rx="0" ry="0" width="284" height="310" />
                    <rect x="30.73" y="377.61" rx="0" ry="0" width="72.09" height="58.32" />
                    <rect x="132.73" y="377.61" rx="0" ry="0" width="74.46" height="55.89" />
                    <rect x="233.73" y="377.61" rx="0" ry="0" width="72.08" height="56.09" />
                    <rect x="329.63" y="377.61" rx="0" ry="0" width="66.42" height="58.32" />
                    <rect x="31.63" y="452.61" rx="0" ry="0" width="353" height="37" />
                    <rect x="33.63" y="504.61" rx="0" ry="0" width="105" height="31" />
                    <rect x="32.63" y="549.61" rx="0" ry="0" width="348.82" height="46" />
                </ContentLoader>
            </div>
        </div>
    </div>
)

export default MobileLoader
